import { render } from "./t_tickets.vue?vue&type=template&id=90261a00&scoped=true"
import script from "./t_tickets.vue?vue&type=script&lang=js"
export * from "./t_tickets.vue?vue&type=script&lang=js"

import "./t_tickets.vue?vue&type=style&index=0&id=90261a00&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\mcc_ssd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90261a00"]])

export default __exports__